import { observable, action, runInAction } from 'mobx'
import { message } from 'antd'
import { map, cloneDeep } from 'lodash'

import { StoreExt } from '@utils/reactExt'
import { socketStore, matchupStore } from '@store/index'
// import { GameType } from '@interface/common'
// import { feed_unified } from '@mongo/feed/feed_unified'

import { socketConnect, socketDisconnect, send } from '@services/websocket'
import { Message } from '@store/socketStore'
import { LiveProtocol } from '@v2/protocol/live-protocol'
import {
  PacketStructure,
  Schema$Result,
  // ISyncEnter,
  // INotifySpecialMatchList,
  // INotifySpecialOddsList,
  Schema$SpecialOdds,
  Schema$SpecialMatch,
} from '@v2/protocol/live'
import { Schema$BinGameRecord } from '@v2/protocol/game'
import { ERR } from 'adv-protocol/src/ErrorCodes'
import { BINARY_GAME_TYPE, BINARY_GAME_HIST_TYPE } from 'adv-protocol/src/GameCommon'
import { canSocketOpen } from '@services/websocket/websocket'
import { isMobile } from 'react-device-detect'
import { GAME_TYPE } from '@game-type/game-market-types'

export enum SPECIAL_ODDS_STATE {
  PHASE_BET,
  PHASE_RESULT,
  PHASE_STANDBY,
}

export enum ODDS_SERVICE_STATE {
  DISCONNECTED = 0,
  CONNECTING = 1,
  CONNECTED = 2,

  ENTERING = 3,
  ENTERED = 4,
}

export const SPECIAL_META = {
  '100000003': {
    name: '토끼와거북이',
    odds: {
      '1': {
        name: '승패',
        oddsField: {
          '1': {
            name: 'DIGIFINEX',
          },
          '2': {
            name: 'IDAX',
          },
        },
        type: 'way',
        calculateOutcome: (close1: number, close2: number) => {
          return [close1, close2]
        },
        resultOutcome: (close1: number, close2: number) => {
          // [좌, 우]
          if (close1 > close2) {
            return [
              { l: '', r: close1 },
              { l: close2, r: '' },
            ]
          }
          return [
            { l: close1, r: '' },
            { l: '', r: close2 },
          ]
        },
      },
      '2': {
        name: '평균의 끝자리 홀짝',
        oddsField: {
          '1': {
            name: '홀',
          },
          '2': {
            name: '짝',
          },
        },
        type: 'oe',
        calculateOutcome: (close1: number, close2: number) => {
          const av = Math.floor((close1 + close2) / 2)
          return [av]
        },
        resultOutcome: (close1: number, close2: number) => {
          // [평균]
          const av = Math.floor((close1 + close2) / 2).toString()
          const l = av.slice(0, av.length - 1)
          const r = av.slice(av.length - 1)
          return [{ l, r }]
        },
      },
      '3': {
        name: '?',
        oddsField: {
          '1': {
            name: '?',
          },
          '2': {
            name: '?',
          },
        },
        calculateOutcome: (close1: number, close2: number) => {
          return [close1, close2]
        },
        resultOutcome: (close1: number, close2: number) => {
          // [?]
          return [{ l: close2, r: '' }]
        },
        type: 'uo',
        skip: true,
      },
    },
  },
  '100000002': {
    name: '코인온도계',
    odds: {
      '1': {
        name: '소수점 승패',
        oddsField: {
          '1': {
            name: 'DIGIFINEX',
          },
          '2': {
            name: 'IDAX',
          },
        },
        type: 'way float',
        calculateOutcome: (close1: number, close2: number) => {
          return [close1, close2]
        },
        resultOutcome: (close1: number, close2: number) => {
          // [좌, 우]
          const tmp1 = close1.toFixed(2).split('.')
          const tmp1L = tmp1.length > 1 ? `${tmp1[0]}.` : tmp1[0]
          const tmp1R = tmp1.length > 1 ? tmp1[1] : ''

          const tmp2 = close2.toFixed(2).split('.')
          const tmp2L = tmp2.length > 1 ? `${tmp2[0]}.` : tmp2[0]
          const tmp2R = tmp2.length > 1 ? tmp2[1] : ''

          if (Number(tmp1R) > Number(tmp2R)) {
            return [
              { l: tmp1L, r: tmp1R },
              { l: `${tmp2L}${tmp2R}`, r: '' },
            ]
          }
          return [
            { l: `${tmp1L}${tmp1R}`, r: '' },
            { l: tmp2L, r: tmp2R },
          ]
        },
      },
      '2': {
        name: '소수점 끝자리의 평균 홀짝',
        oddsField: {
          '1': {
            name: '홀',
          },
          '2': {
            name: '짝',
          },
        },
        type: 'oe float',
        calculateOutcome: (close1: number, close2: number) => {
          const av = Math.floor((+(close1 * 100).toFixed(12) + +(close2 * 100).toFixed(12)) / 2) / 100
          return [av]
        },
        resultOutcome: (close1: number, close2: number) => {
          // [평균]
          const av = Math.floor((+(close1 * 100).toFixed(12) + +(close2 * 100).toFixed(12)) / 2) / 100
          const tmp = av.toString()
          const l = tmp.slice(0, tmp.length - 1)
          const r = tmp.slice(tmp.length - 1)
          return [{ l, r }]
        },
      },
      '3': {
        name: '?',
        oddsField: {
          '1': {
            name: '?',
          },
          '2': {
            name: '?',
          },
        },
        calculateOutcome: (close1: number, close2: number) => {
          return [close1, close2]
        },
        resultOutcome: (close1: number, close2: number) => {
          // [?]
          return [{ l: close2, r: '' }]
        },
        type: 'uo',
        skip: true,
      },
    },
  },
  '100000001': {
    name: '비트코인',
    odds: {
      '1': {
        name: '기준가 언더오버',
        oddsField: {
          '1': {
            name: '언더',
          },
          '2': {
            name: '오버',
          },
        },
        type: 'uo',
        calculateOutcome: (close1: number, close2: number) => {
          return [close1, close2]
        },
        resultOutcome: (close1: number, close2: number) => {
          // [기준점, 마감값]
          return [
            { l: close1, r: '' },
            { l: '', r: close2 },
          ]
        },
      },
      '2': {
        name: '소수점 끝자리의 평균 홀짝',
        oddsField: {
          '1': {
            name: '홀',
          },
          '2': {
            name: '짝',
          },
        },
        type: 'oe float',
        calculateOutcome: (close1: number, close2: number) => {
          const av = Math.floor((+(close1 * 100).toFixed(12) + +(close2 * 100).toFixed(12)) / 2) / 100
          return [av]
        },
        resultOutcome: (close1: number, close2: number) => {
          // [평균]
          const av = Math.floor((+(close1 * 100).toFixed(12) + +(close2 * 100).toFixed(12)) / 2) / 100
          const tmp = av.toString()
          const l = tmp.slice(0, tmp.length - 1)
          const r = tmp.slice(tmp.length - 1)
          return [{ l, r }]
        },
        skip: true,
      },
      '3': {
        name: '소수점 이하 언더오버',
        oddsField: {
          '1': {
            name: '언더',
          },
          '2': {
            name: '오버',
          },
        },
        calculateOutcome: (close1: number, close2: number) => {
          const ss = close2.toString().split('.')
          if (ss.length === 2) {
            return ['49.5', ss[1]]
          }
          return ['49.5', '?']
        },
        resultOutcome: (close1: number, close2: number) => {
          // [기준점, 마감값]
          const ss = close2.toString().split('.')
          if (ss.length === 2) {
            return [
              { l: '49.5', r: '' },
              { l: '', r: ss[1] },
            ]
          }
          return [{ l: '49.5', r: '' }]
        },
        type: 'uo',
      },
    },
  },
}

const coroutineInTimer = async (func: () => void, timeout): Promise<void> => {
  return new Promise(resolve => {
    setTimeout(() => {
      func()
      resolve()
    }, timeout)
  })
}

const coroutineInCondition = async (func: () => boolean, delays = 200): Promise<void> => {
  return new Promise(resolve => {
    const funcLoop = () => {
      setTimeout(() => {
        const ret = func()
        if (ret === true) {
          resolve()
        } else {
          funcLoop()
        }
      })
    }
    funcLoop()
  })
}

export type BinGameRecord = Schema$BinGameRecord

export type SpecialOdds = Schema$SpecialOdds

export interface SpecialMatch extends Schema$SpecialMatch {
  hostTime?: Date
  localTime?: Date
  offset?: number
  state?: number
}

export interface SpecialMatchTrack extends Schema$SpecialMatch {
  dateOfMatchInst?: Date

  timeGameStart?: Date
  timeBetStart?: Date
  timeBetEnd?: Date
  timeGameEnd?: Date
  timeStandby?: Date
  timeDiff?: number

  state?: number

  odds?: { [type: string]: SpecialOdds }
}

export class OddsStore extends StoreExt {
  @observable
  serviceState = ODDS_SERVICE_STATE.DISCONNECTED

  @observable
  gameType = ''

  // 최신 데이터 유지
  @observable
  specialTrack: SpecialMatchTrack

  matches: { [sportId: string]: { [matchId: string]: SpecialMatch } }

  @observable
  gameList: BinGameRecord[]

  @observable
  isOddsConnected = false

  url: string

  health_check_time = 30

  constructor() {
    super()
    this.url = process.env.ODDS_BASE_URL
    this.matches = {}
  }

  documentVisibleChangeHandler = (isHidden: boolean): void => {
    if (!isMobile) {
      return
    }

    if (matchupStore.currentGameKey !== GAME_TYPE.LIVE) {
      return
    }

    if (isHidden) {
      this.cleanup()
    } else {
      this.enter('unified')
    }
  }

  @action
  cleanup = () => {
    socketDisconnect()
    this.setServiceState(ODDS_SERVICE_STATE.DISCONNECTED)

    this.gameType = ''
    this.specialTrack = undefined
    this.matches = {}
    this.gameList = []
    this.isOddsConnected = false
  }

  @action
  enter = async (gameType: string) => {
    try {
      this.gameType = gameType
      // LIVE_STATE.CONNECTING
      await coroutineInTimer(() => {
        this.setServiceState(ODDS_SERVICE_STATE.CONNECTING)
      }, 1000)
      if (socketStore.socketIsConnected === false) {
        socketConnect(this.url)
        await coroutineInCondition(() => {
          return socketStore.socketIsConnected
        })
        // LIVE_STATE.CONNECTED
        await coroutineInTimer(() => {
          this.setServiceState(ODDS_SERVICE_STATE.CONNECTED)
        }, 100)
      } else {
        console.error('OddsStore.enter already LIVE_STATE.CONNECTED')
      }
      // LIVE_STATE.ENTERING
      await coroutineInTimer(() => {
        this.setServiceState(ODDS_SERVICE_STATE.ENTERING)
      }, 1000)

    } catch (err) {
      console.error(err.message)
    }
  }

  @action
  onOpen = () => {
    // 이미 odds 서버의 서비스에 입장하였어도 입장을 요청한다.(서버쪽에서 같은 인스턴스에 대한 중복 처리)
    const gameType = this.gameType
    this.sendPacket(LiveProtocol.SYNC_ENTER, {
      authKey: '',
      overlapLogin: '',
      gameType,
    })
    this.isOddsConnected = true
    matchupStore.updateOldRateFromCurrentRate()
  }

  @action
  fetchBinGameRecord = async (gameKey: number) => {
    try {
      runInAction(() => {
        this.gameList = []
      })

      const { gameList } = await this.api.game.getBinGameRecord({
        offset: 0,
        binGameType: gameKey,
        listType: BINARY_GAME_HIST_TYPE.PAST_HOURS,
        searchDay: new Date(),
      })

      runInAction(() => {
        this.gameList = gameList
      })
    } catch (err) {
      console.error(err)
      message.warn('요청에 실패했습니다.')
    }
  }

  sendPacket = (protocol: number, data) => {
    send(null, {
      protocol,
      data,
    })
  }

  healthCheck = () => {
    setTimeout( () => {
      if (!canSocketOpen()) {
        this.sendPacket(LiveProtocol.SYNC_HEALTH_CHECK, null)
        this.healthCheck()
      }
    }, this.health_check_time * 1000)
  }

  @action
  dispatchMessage = (msg: Message) => {
    if (msg.from !== 'server') {
      return
    }
    if (msg.data === 'SR') {
      return
    }

    try {
      const packet = JSON.parse(msg.data) as PacketStructure
      const { data } = packet
      const raw = data as Schema$Result

      if (raw.errcode !== ERR.OK) {
        message.error(`Live errcode = ${raw.errcode}`)
        return
      }
      switch (packet.protocol) {
        case LiveProtocol.SYNC_ENTER:
          if(isMobile) {
            this.healthCheck()
          }
          break
        case LiveProtocol.NOTIFY_SPECIAL_MATCH_LIST: {
          // do not cast overlapped object! use destructing
          const { hostTime, items } = data
          const now = new Date()
          const hostTimeInst = new Date(hostTime)
          // let count = 0
          for (const el of items as Schema$SpecialMatch[]) {
            // count += 1
            // if (el.sportId === currentSpecialKey) {
            //   const a = 0
            // }

            if (!this.matches[el.sportId]) {
              this.matches[el.sportId] = {}
            }

            const updateHostTimeInst = new Date(el.updateHostTime)
            const dateOfMatch = new Date(el.dateOfMatch)
            const hostMatchOffset = dateOfMatch.valueOf() - hostTimeInst.valueOf()
            const hostUpdateOffset = updateHostTimeInst.valueOf() - dateOfMatch.valueOf()
            // const hostLocalDiff = now.valueOf() - hostTimeInst.valueOf()
            // const diffSum = hostMatchDiff + hostLocalDiff
            const offset = hostMatchOffset + hostUpdateOffset

            this.matches[el.sportId][el.matchId] = el as SpecialMatch
            this.matches[el.sportId][el.matchId].hostTime = hostTimeInst
            this.matches[el.sportId][el.matchId].localTime = new Date(now)
            this.matches[el.sportId][el.matchId].offset = offset

            const meta = SPECIAL_META[el.sportId]

            const oddsList = Object.values(el.odds)
            this.matches[el.sportId][el.matchId].odds = {}
            for (const odds of oddsList) {
              const { skip } = meta.odds[odds.oddsType]
              if (skip === true) {
                continue
              }
              this.matches[el.sportId][el.matchId].odds[odds.oddsType] = odds
            }
          }
        }
          break
        case LiveProtocol.NOTIFY_SPECIAL_ODDS_LIST: {
          const { items = [] } = data
          // const hostTimeInst = new Date(hostTime)

          // const now = new Date()
          for (const el of items as Schema$SpecialOdds[]) {
            const meta = SPECIAL_META[el.sportId]
            const { skip } = meta.odds[el.oddsType]
            if (skip === true) {
              continue
            }
            if (this.matches[el.sportId] && this.matches[el.sportId][el.matchId]) {
              if (!this.matches[el.sportId][el.matchId].odds) {
                this.matches[el.sportId][el.matchId].odds = {}
              }
              this.matches[el.sportId][el.matchId].odds[el.oddsType] = el
              // this.matches[el.sportId][el.matchId].odds[el.oddsType].hostTime = hostTimeInst
              // this.matches[el.sportId][el.matchId].odds[el.oddsType].localTime = new Date(now)
              this.matches[el.sportId][el.matchId].state = el.state
            }
          }

          this.updateSpecialTrack()
        }
          break
        case LiveProtocol.UNIFIED_FEED:
          matchupStore.updateUnifiedFeed(data)
          break
        case LiveProtocol.UNIFIED_STATUS:
          matchupStore.updateUnifiedStatus(data)
          break
        case LiveProtocol.SYNC_HEALTH_CHECK:
          break
        case LiveProtocol.SYNC_PING:
          this.sendPacket(LiveProtocol.SYNC_PONG, null)
          break
      }
    } catch (err) {
      console.error(err.message)
      console.error(err.stack)
    }
  }

  @action
  updateSpecialTrack = async (): Promise<SpecialMatchTrack> => {
    let srcMatch: SpecialMatch
    let newTrack: SpecialMatchTrack
    const { currentSpecialKey } = matchupStore
    if (this.matches[currentSpecialKey]) {
      let keys = map(this.matches[currentSpecialKey], e => {
        return e.matchId
      })
      keys = keys.sort((a, b) => {
        return a - b
      })
      if (keys.length > 0) {
        const targetMatchId = keys[keys.length - 1]
        srcMatch = this.matches[currentSpecialKey][targetMatchId]
        newTrack = cloneDeep(srcMatch) as SpecialMatchTrack
      }
    }

    // adjust time
    if (newTrack) {
      const timeGameStart = new Date(srcMatch.localTime)
      timeGameStart.setMilliseconds(timeGameStart.getMilliseconds() + srcMatch.offset)

      const timeBetStart = new Date(timeGameStart) // 매칭 시작시간부터

      const timeBetEnd = new Date(timeBetStart) // 베팅 시작시간부터
      timeBetEnd.setSeconds(timeBetEnd.getSeconds() + newTrack.betAvailableTime)

      const timeGameEnd = new Date(timeGameStart)
      switch (newTrack.sportId) {
        case BINARY_GAME_TYPE.BITCOIN:
          timeGameEnd.setMinutes(timeGameEnd.getMinutes() + 2)
          break
        case BINARY_GAME_TYPE.BIT_THERMO:
          timeGameEnd.setMinutes(timeGameEnd.getMinutes() + 1)
          break
        case BINARY_GAME_TYPE.BIT_RABBIT:
          timeGameEnd.setMinutes(timeGameEnd.getMinutes() + 1)
          break
      }
      timeGameEnd.setSeconds(timeGameEnd.getSeconds() - newTrack.betReadyTime)

      const timeStandby = new Date(timeGameEnd)
      timeStandby.setSeconds(timeStandby.getSeconds() + newTrack.betReadyTime)

      newTrack.dateOfMatchInst = new Date(newTrack.dateOfMatch)
      newTrack.timeGameStart = timeGameStart
      newTrack.timeBetStart = timeBetStart
      newTrack.timeBetEnd = timeBetEnd
      newTrack.timeGameEnd = timeGameEnd
      newTrack.timeStandby = timeStandby
      // newTrack.timeDiff = srcMatch.hostTime.valueOf() - srcMatch.localTime.valueOf()
      newTrack.state = srcMatch.state

      if (newTrack.state !== 0) {
        matchupStore.clearCart()
      }
    }

    return this.setSpecialTrack(newTrack)
  }

  @action
  setSpecialTrack = (track: SpecialMatchTrack): SpecialMatchTrack => {
    this.specialTrack = track
    return track
  }

  @action
  setSpecialKey = (key: number) => {
    matchupStore.setSpecialKey(key)
    this.updateSpecialTrack()
  }

  @action
  setServiceState = (state: ODDS_SERVICE_STATE): ODDS_SERVICE_STATE => {
    this.serviceState = state
    return state
  }

  // @action
  // setLatestMatch = (sportId: string, track: SpecialOddsTrack) => {
  //   this.latestMatchMap.set(sportId, track)
  //   return track
  // }
}

export default new OddsStore()
